import React, { ReactElement } from 'react';
import { classNames } from '../../utils/style';
import { RowProps } from './Row';

export type ColumnsProps = {
  children: ReactElement<RowProps> | ReactElement<RowProps>[];
  className?: string;
};

export const Columns = ({ children, className }: ColumnsProps) => {
  return (
    <div className={classNames('Columns flex flex-wrap gap-[20px]', className)}>
      {children}
    </div>
  );
};
